import { createTaskFilterFunction, RunbookFilterType } from './filters'
import { TaskListTask } from 'main/services/queries/types'

export const active = createTaskFilterFunction('at', (task: TaskListTask, filters: RunbookFilterType): boolean => {
  const activeStages = ['startable', 'in-progress']
  return filters.at ? activeStages.includes(task.stage) : !activeStages.includes(task.stage)
})
